import React from 'react';

import { Text } from '@infinex/ui/components';

import { formatFunctionName } from '../helpers';

interface EvmFunctionNameProps {
  functionName: string;
}

export function EvmFunctionName({ functionName }: EvmFunctionNameProps) {
  return (
    <div className="flex items-center justify-between">
      <Text className="text-default text-sm font-medium">Function</Text>
      <Text className="text-emphasis text-sm font-medium">
        {formatFunctionName(functionName)}
      </Text>
    </div>
  );
}
